import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Badge } from '@/components/ui/badge';
import { Puzzle } from 'lucide-react';

const diffColors = { easy:'bg-emerald-100 text-emerald-700', medium:'bg-amber-100 text-amber-700', hard:'bg-rose-100 text-rose-700' };

export default function ExercisesPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/exercises').then(r => setItems(r.data)); }, []);
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <PageHeader title="Ejercicios tácticos" subtitle="Resuelve puzzles y gana puntos" testId="exercises-header"/>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map(e => (
          <Link key={e.id} to={`/student/exercises/${e.id}`} data-testid={`exercise-${e.id}`}
            className="rounded-2xl bg-white border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-lg transition-all">
            <div className="flex items-center justify-between mb-3">
              <div className="w-10 h-10 rounded-xl bg-blue-100 text-blue-700 grid place-items-center"><Puzzle className="w-5 h-5"/></div>
              <Badge className={diffColors[e.difficulty] || 'bg-slate-100 text-slate-700'}>{e.difficulty}</Badge>
            </div>
            <div className="font-display font-bold text-lg">{e.title}</div>
            <div className="text-sm text-slate-500 mt-1 line-clamp-2">{e.description}</div>
            <div className="mt-3 text-xs font-mono text-amber-600">+{e.points} pts</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
